import { motion } from "framer-motion";
import ScrollDownIndicator from "shared/ScrollDownIndicator/ScrollDownIndicator";
import LucideIcon from "utils/LucideIcon";

const fadeInDown = {
  hidden: { opacity: 0, y: -40 },
  visible: (custom: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom * 0.2,
      duration: 0.8,
      ease: "easeOut" as const,
    },
  }),
};

const fadeIn = {
  hidden: { opacity: 0 },
  visible: (custom: number) => ({
    opacity: 1,
    transition: {
      delay: custom * 0.2,
      duration: 0.8,
      ease: "easeOut" as const,
    },
  }),
};

const SectionAboutUsHero: React.FC = () => {
  return (
    <section className="flex flex-col items-center justify-center overflow-hidden py-2 mt-8 md:mt-0 md:pt-12">
      <div className="container mx-auto px-4 text-center max-w-6xl">
        {/* Badge */}
        <motion.div
          custom={0}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeIn}
          className="inline-flex items-center gap-2 bg-pink-200/10 hover:bg-pink-200/20 backdrop-blur-md rounded-full px-6 py-3 border border-blue-400/40 mb-5 transition-all duration-300"
        >
          {/* <BookOpen className="w-5 h-5 text-purple-500/90 animate-pulse" /> */}
          <LucideIcon
            name="BookOpen"
            className="w-5 h-5 text-purple-500/90 hover:text-purple-500/90 mr-3"
          />
          <span className="text-blue-600 font-medium font-inter">About Us</span>
        </motion.div>

        {/* Headline */}
        <motion.h1
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeIn}
          className="text-4xl md:text-6xl lg:text-8xl font-bold mb-8 leading-normal"
        >
          <span className="text-secondary-gradient bg-clip-text text-transparent font-inter block leading-normal">
            Redefining Gifting
          </span>
          <span className="text-2xl md:text-4xl xl:text-5xl text-secondary-gradient bg-clip-text text-transparent font-inter block leading-loose pb-1">
            With Purpose And Precision
          </span>
        </motion.h1>

        {/* Subtext */}
        <motion.p
          custom={2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeIn}
          className="text-lg md:text-xl text-gray-600/80 mb-12 max-w-4xl mx-auto leading-relaxed font-inter"
        >
          We're not just curators. We're strategists. At 360Customizer, every gift is backed by research, relevance, and a commitment to creating value driven experiences. We don't sell products. We deliver impact, thoughtfully crafted for the people who matter most to your brand.
        </motion.p>
      </div>
      <motion.div
        custom={3}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInDown}
        className="mt-6 md:mt-0"
      >
        <ScrollDownIndicator
          targetId="work"
          className="bg-secondary-gradient"
        />
      </motion.div>
    </section>
  );
};

export default SectionAboutUsHero;
